import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setPopupState } from '../../model/configuratorSlice';
import { PopupState } from '../../model/constants';
import { EyeOff, EyeOn } from '../../shared/svg/components';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import LoginService from '../../services/LoginService';

const Login = () => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const loginMutation = LoginService();
    const dispatch = useDispatch();

    const errorCallback = () => {
        setHasError(true);
        setIsProcessing(false);
    };
    const login = () => {
        const email = document.getElementById('email');
        const password = document.getElementById('password');
        setIsProcessing(true);
        loginMutation.mutate({
            email: email.value,
            password: password.value,
            errorCallback,
        });
        dispatch(setPopupState(PopupState.None));
    };

    const handlePasswordVisible = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const onInputChanged = (event) => {
        setHasError(false);
    };

    const isLoginPopupOpened = true;

    return (
      <div className={`login-popup ${isLoginPopupOpened ? ' opened' : ''}`}>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <div
          className={`background ${isLoginPopupOpened ? 'opened' : ''}`}
        />
        <div className={`background${isLoginPopupOpened ? ' opened' : ''}`} />
        <div className={`panel${isLoginPopupOpened ? ' opened' : ''}`}>
          <div className="header">
            {TranslationUtility.GetFormattedMessageForUI('ui-login-panel-title', 'Iniciar Sesión')}
          </div>
          <div className="container-form">
            <form>
              <div className="user-title">
                {TranslationUtility.GetFormattedMessageForUI('ui-login-panel-username-title', 'USUARIO')}
              </div>
              <input
                className="user-value"
                type="email"
                id="email"
                placeholder=""
                onChange={onInputChanged}
              />
              <div className="password-title">
                {TranslationUtility.GetFormattedMessageForUI('ui-login-panel-password-title', 'CONTRASEÑA')}
              </div>
              <div className="password-container">
                <input
                  className="password-value"
                  type={isPasswordVisible ? 'text' : 'password'}
                  id="password"
                  placeholder=""
                  onChange={onInputChanged}
                />
                <button type="button" className="password-visible-button" onClick={handlePasswordVisible}>
                  <EyeOn className={`icon ${!isPasswordVisible ? '' : ' hidden'}`} />
                  <EyeOff className={`icon ${isPasswordVisible ? '' : ' hidden'}`} />
                </button>
              </div>

            </form>
          </div>
          <div className="error-message">{hasError ? 'El usuario o la contraseña son incorrectos.' : ''}</div>
          <div className="container-buttons">
            <button
              className="login-button"
              type="button"
              onClick={() => login()}
              disabled={isProcessing}
            ><span>Entrar</span>
            </button>
          </div>
        </div>
      </div>
    );
};

export default Login;
